import { GROWTHBOOK_LOADED } from '../../constants/experiment';
import {
  SET_IS_CONFIGURATION_LOADED,
  SET_IS_RENDERED,
  SET_IS_THEME_APPLIED,
  SET_USE_DEBUG_MODE,
  SET_COMMON_APP_LOCAL_GAME_LAUNCH_MODE,
  SET_CASINO_APP_LOCAL_GAME_LAUNCH_MODE,
  LOCALIZATION_INITIALIZED,
  SET_IS_BASE_PARAMS_RECEIVED,
} from '../../constants/initialization';
import type { RootState } from '../../store';

export interface InitializationState {
  isConfigurationLoaded: boolean;
  isBaseParamsSetUp: boolean;
  isRendered: boolean;
  isThemeApplied: boolean;
  useDebug: boolean;
  useCommonAppLocalGameLaunchMode: boolean;
  useCasinoAppLocalGameLaunchMode: boolean;
  isLocalizationInitialized: boolean;
  isFeatureConfigInitialized: boolean;
}

export const initialState = {
  isConfigurationLoaded: false,
  isBaseParamsSetUp: false,
  isRendered: false,
  isThemeApplied: false,
  useDebug: false,
  useCommonAppLocalGameLaunchMode: false,
  useCasinoAppLocalGameLaunchMode: false,
  isLocalizationInitialized: false,
  isFeatureConfigInitialized: false,
};

const initialization = (
  state = initialState,
  { type, payload }: { type: string; payload: boolean }
): InitializationState => {
  switch (type) {
    case SET_IS_CONFIGURATION_LOADED:
      return { ...state, isConfigurationLoaded: payload };
    case SET_IS_BASE_PARAMS_RECEIVED:
      return { ...state, isBaseParamsSetUp: payload };
    case SET_IS_RENDERED:
      return { ...state, isRendered: payload };
    case SET_USE_DEBUG_MODE:
      return { ...state, useDebug: payload };
    case SET_COMMON_APP_LOCAL_GAME_LAUNCH_MODE:
      return { ...state, useCommonAppLocalGameLaunchMode: payload };
    case SET_CASINO_APP_LOCAL_GAME_LAUNCH_MODE:
      return { ...state, useCasinoAppLocalGameLaunchMode: payload };
    case SET_IS_THEME_APPLIED:
      return { ...state, isThemeApplied: payload };
    case LOCALIZATION_INITIALIZED:
      return { ...state, isLocalizationInitialized: payload };
    case GROWTHBOOK_LOADED:
      return { ...state, isFeatureConfigInitialized: true };

    default:
      return state;
  }
};

export default initialization;

/**
 * SELECTORS
 */
export const isConfigurationLoadedSelector = (state: RootState) =>
  state?.app?.initialization?.isConfigurationLoaded;
export const isRenderedSelector = (state: RootState) =>
  state?.app?.initialization?.isRendered;
export const setIsBaseParamsSetUpSelector = (state: RootState) =>
  state?.app?.initialization?.isBaseParamsSetUp;
export const isDebugModeSelector = (state: RootState) =>
  state?.app?.initialization?.useDebug;
export const isCommonAppLocalGameLaunchMode = (state: RootState) =>
  state?.app?.initialization?.useCommonAppLocalGameLaunchMode;
export const isCasinoAppLocalGameLaunchMode = (state: RootState) =>
  state?.app?.initialization?.useCasinoAppLocalGameLaunchMode;
export const isThemeAppliedSelector = (state: RootState) =>
  state?.app?.initialization?.isThemeApplied;
export const isLocalizationInitializedSelector = (state: RootState) =>
  state?.app?.initialization?.isLocalizationInitialized;
export const isFeatureConfigInitializedSelector = (state: RootState) =>
  state?.app?.initialization?.isFeatureConfigInitialized;
